import FD from '../RestAPI/fetchData';
import App_data from '../config/App_data';

// const requestHandler = response => {
//   if (response.status) {
//     return response;
//   } else {
//     return { errorMessage: response.errorMessage };
//   }
// };

const route = {
  QUESTION: '/esg/question',
  CBT: '/esg/cbt',
  DASHBOARD: '/esg/dashboard',
  VIDEOS: '/esg/videos',
};

// ----------------> DASHBOARD API SERVICES START HERE <----------------
const fetchTotalUsersBarGraph = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/total-user-bar-graph`, data);
};
const fetchUsersBarGraph = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/user-bar-graph`, data);
};
const deleteFlashCard = async data => {
  return await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, data);
};
const fetchQuestionProgressBar = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/question-progress-bar`, data);
};
const fetchSavedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/saved-question`, data);
};
const deleteSavedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/delete-saved-question`, data);
};
const fetchReportedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/reported-question`, data);
};
const deleteReportedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/delete-reported-question`, data);
};
const fetchCBTReportedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/cbt-reported-question`, data);
};
const deleteCBTReportedQuestion = async data => {
  return await FD.callAPI(
    `${App_data.backend_api}/esg/dashboard/cbt-delete-reported-question`,
    data,
  );
};

const redirectToQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/redirect-to-question`, data);
};
const redirectToCBTQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/cbt-redirect-to-question`, data);
};
const updateReportedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/dashboard/update-reported-question`, data);
};
const updateReportedCBTQuestion = async data => {
  return await FD.callAPI(
    `${App_data.backend_api}/esg/dashboard/cbt-update-reported-question`,
    data,
  );
};
// ----------------> DASHBOARD API SERVICES ENDED HERE <----------------

const fetchQuestionsChapterWise = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question`, data);
};

const fetchChapterNameById = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/chapter-by-id`, data);
};

const reportQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/report`, data);
};

const saveQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/save`, data);
};
const deleteSaveQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/delete-save`, data);
};

const getFavQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/get-fav`, data);
};

const fetchNotePDFById = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/notes/pdf-by-id`, data);
};

const getTokenAndEmail = () => {
  const storageSession = JSON.parse(localStorage.getItem('localstorageval'));
  return {
    idname: storageSession['idname'],
    token: storageSession['token'],
  };
};

const getImagePath = imgSrc => `${App_data.frontend_url}${imgSrc}`;

// const getQuestionsListByReadingId = async data => {
//   return await FD.callAPI(`${App_data.backend_api}/esg/question`, data);
// };

const generateTestId = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/generate-test-id`, data);
};

const getUserStatsByMockId = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/mock-user-stats`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const deleteUserAttemptedMockExamAPICall = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/delete-user-attempted-mock-exam`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const getMockDetailsById = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-mock-details-by-id`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const saveMockUserChoice = async data => {
  return FD.callAPI(`${App_data.backend_api}/esg/cbt/validate-users-answer-choice`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const mockQuestions = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/mock-questions`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const getUserStatsByTestId = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-user-stats-by-test-id`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const flagUnFlagSelectedQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/flag-unFlag-selected-question`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const reportCBTQuestion = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/report`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const getUserTimeByTestId = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-user-time-by-test-id`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const updateUserTimer = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/update-user-timer`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const setTestStatusByTestId = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/mark-mock-status-as-completed`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const setCBTScore = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/update-score-by-test-id`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const getCBTScore = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-score-by-test-id`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const fetchChapterWiseCount = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/chapter-wise-count`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const fetchChapterWiseAnswerCount = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/chapter-wise-answer-count`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const setUserChoice = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/set-user-choice`, {
    ...data,
    ...getTokenAndEmail(),
  });
};

const saveQuestionStats = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/save-stats`, {
    ...getTokenAndEmail(),
    ...data,
  });
};

const pdfDownloadViaEmail = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/question/pdf-download-via-email`, {
    ...getTokenAndEmail(),
    ...data,
  });
};

const viewPDF = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/view-pdf`, {
    ...getTokenAndEmail(),
    ...data,
  });
};

const fetchCBTOverallUserGraph = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-mock-user-graph`, {
    ...getTokenAndEmail(),
    ...data,
  });
};

const fetchCBTChapterWiseGraph = async data => {
  return await FD.callAPI(`${App_data.backend_api}/esg/cbt/get-mock-user-graph-chapter-wise`, {
    ...getTokenAndEmail(),
    ...data,
  });
};

const postApiCalling = (route, endpoint, data) => {
  return FD.callAPI(`${App_data.backend_api}${route}${endpoint}`, {
    ...getTokenAndEmail(),
    ...data,
  });
};
const getHighlightedTextService = async data =>
  await postApiCalling(route.CBT, '/get-high-lighted-text', data);

const deleteHighlightService = async data =>
  await postApiCalling(route.CBT, '/delete-high-lighted-text', data);

const addHighlightedTextService = async data =>
  await postApiCalling(route.CBT, '/add-high-lighted-text', data);

const addStrikeThrough = async data => await postApiCalling(route.CBT, '/addStrikeThrough', data);

const getStrikedText = async data => await postApiCalling(route.CBT, '/getStrikedText', data);

const fetchLastAnsweredQuestion = async (data = {}) =>
  await postApiCalling(route.QUESTION, '/getLastAnsweredQuestion', data);

const getQuestionChapterwise = async (data = {}) =>
  await postApiCalling(route.QUESTION, '/getQuestionChapterwise', data);

const getAllVideos = async (data = {}) => await postApiCalling(route.VIDEOS, '/getAllVideos', data);

const getVideosByChapter = async (data = {}) =>
  await postApiCalling(route.VIDEOS, '/getVideoByChapterId', data);

const getLastVideo = async (data = {}) =>
  await postApiCalling(route.VIDEOS, '/getLastViewedVideo', data);

const fetchSavedVideos = async data => {
  return await postApiCalling(route.VIDEOS, '/saved-videos', data);
};
const deleteSavedVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/delete-saved-video', data);
};
const fetchReportedVideos = async data => {
  return await postApiCalling(route.VIDEOS, '/reported-videos', data);
};
const deleteReportedVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/delete-reported-video', data);
};

const mutateSaveVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/save-video', data);
};

const mutateReportVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/report-video', data);
};

const getFavVideoById = async data => {
  return await postApiCalling(route.VIDEOS, '/saved-video-by-id', data);
};
const deleteFavVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/delete-fav-video', data);
};
const updateReportedVideo = async data => {
  return await postApiCalling(route.VIDEOS, '/update-reported-video', data);
};

const redirectToVideo = async data => {
  return await postApiCalling(route.DASHBOARD, '/redirect-to-video', data);
};

module.exports = {
  deleteHighlightService,
  getHighlightedTextService,
  addHighlightedTextService,
  // ESG DASHBOARD
  fetchTotalUsersBarGraph,
  fetchUsersBarGraph,
  fetchSavedQuestion,
  fetchReportedQuestion,
  deleteSavedQuestion,
  deleteReportedQuestion,
  fetchCBTReportedQuestion,
  deleteCBTReportedQuestion,
  redirectToQuestion,
  redirectToCBTQuestion,
  fetchQuestionProgressBar,
  updateReportedQuestion,
  updateReportedCBTQuestion,

  fetchQuestionsChapterWise,
  fetchChapterNameById,
  getTokenAndEmail,
  reportQuestion,
  saveQuestion,
  getFavQuestion,
  saveQuestionStats,
  fetchNotePDFById,
  getImagePath,
  // updateUsersChoice,
  // updateUserAnswer,
  generateTestId,
  getUserStatsByMockId,
  deleteUserAttemptedMockExamAPICall,
  getMockDetailsById,
  saveMockUserChoice,
  mockQuestions,
  getUserStatsByTestId,
  flagUnFlagSelectedQuestion,
  //   getQuestionsListByReadingId,
  reportCBTQuestion,
  getUserTimeByTestId,
  updateUserTimer,
  setTestStatusByTestId,
  setCBTScore,
  setUserChoice,
  pdfDownloadViaEmail,
  viewPDF,
  getCBTScore,
  fetchChapterWiseAnswerCount,
  fetchChapterWiseCount,
  fetchCBTOverallUserGraph,
  fetchCBTChapterWiseGraph,
  addStrikeThrough,
  getStrikedText,
  fetchLastAnsweredQuestion,
  getQuestionChapterwise,
  getAllVideos,
  getVideosByChapter,
  getLastVideo,
  fetchSavedVideos,
  deleteSavedVideo,
  fetchReportedVideos,
  deleteReportedVideo,
  mutateSaveVideo,
  mutateReportVideo,
  deleteSaveQuestion,
  getFavVideoById,
  deleteFavVideo,
  updateReportedVideo,
  redirectToVideo,
  deleteFlashCard,
};



// WEBPACK FOOTER //
// ./src/views/ESG/services.js